export default __webpack_public_path__ + "static/media/check-in-banner-ms.736046a4.webp";